import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Plus, Loader2, CalendarDays, MapPin, Clock } from "lucide-react";
import { api, errMsg, fmtDay } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PageHeader } from "@/components/StatusBadge";

export const MinutesStatus = ({ status, testid }) => (
  <span data-testid={testid} className={`text-[11px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded-full ${status === "finalised" ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-800"}`}>{status}</span>
);

export default function MinutesList() {
  const [d, setD] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => {
    const h = setTimeout(() => api.get("/minutes", { params: { q } }).then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))), 250);
    return () => clearTimeout(h);
  }, [q]);
  return (
    <div>
      <PageHeader eyebrow="Main Secretariat" title="MIT Minutes" testid="minutes-title">
        {d?.can_edit && <Button asChild data-testid="minutes-new-button"><Link to="/minutes/new"><Plus className="w-4 h-4 mr-1" />New minutes</Link></Button>}
      </PageHeader>
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by date (e.g. 2026-03) or venue…" className="bg-white mb-4 max-w-md" data-testid="minutes-search-input" />
      {!d ? <div className="p-10 grid place-items-center"><Loader2 className="w-5 h-5 animate-spin text-slate-400" /></div> : (
        <div className="grid gap-3" data-testid="minutes-list">
          {d.items.length === 0 && <div className="rounded-lg border border-slate-200 bg-white p-10 text-center text-slate-500" data-testid="minutes-empty">No minutes yet.</div>}
          {d.items.map((m) => (
            <Link key={m.minutes_id} to={`/minutes/${m.minutes_id}`} data-testid={`minutes-item-${m.minutes_id}`}
              className="rounded-lg border border-slate-200 bg-white shadow-sm p-4 flex flex-wrap items-center gap-x-6 gap-y-2 hover:-translate-y-0.5 transition-transform duration-200">
              <span className="font-mono text-xs font-bold text-slate-800">{m.number}</span>
              <span className="flex items-center gap-1.5 text-sm text-slate-800"><CalendarDays className="w-4 h-4 text-amber-600" />{m.fields?.date ? fmtDay(m.fields.date) : "No date"}</span>
              {m.fields?.time && <span className="flex items-center gap-1.5 text-sm text-slate-600"><Clock className="w-4 h-4" />{m.fields.time}</span>}
              <span className="flex items-center gap-1.5 text-sm text-slate-600"><MapPin className="w-4 h-4" />{m.fields?.venue || "—"}</span>
              <span className="ml-auto"><MinutesStatus status={m.status} /></span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
